


import { POST } from "../API";
let source = null;

export const addGroupMembersAPI = (id, members, onSuccess, onError, conversation_id = null) => {
    // const data = {
    //     id: id,
    //     members: members
    // }
    const data = conversation_id
        ? { conversation_id: conversation_id, members: members }
        : { id: id, members: members };
    POST(`/api/v1/chat/groups/add_members`, data, onSuccess, onError,);
};
